import React from 'react'
import { connect } from 'react-redux'

import { CloseButton } from '../../../../components'
import RouteDebugTable from './RouteDebugTable.jsx'
import RouteTile from './RouteTile.jsx'
import { unhighlightRoute } from '../../actions'

const RouteGridItemContent = ({
    routeId, showCloseBtn, debugging, onClose,
}) => (
    <>
        <RouteTile routeId={routeId} />
        {debugging && <RouteDebugTable routeId={routeId} />}
        {showCloseBtn && <CloseButton onClick={onClose} />}
    </>
)

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ debugging, isMapView, highlight }, { routeId }) => ({
    showCloseBtn: isMapView && highlight === routeId,
    debugging,
})

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(unhighlightRoute()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteGridItemContent)
